import { ACTIONS } from '@~/actions/cue-analytics';
import { IS_DEV, IS_STAGING } from '@~/constants/app-config';

const CONFIG = {
  env: IS_STAGING || IS_DEV ? 'development' : 'production',
  debug: false,
  product: 'leap_student',
};

const initialState = {
  data: {},
  user_identify: {},
  config: CONFIG,
  timestamp: null,
};

export default function defaultExport(state = initialState, { type, payload }) {
  if (type === ACTIONS.SET_CUE_ANALYTICS_DATA) {
    return {
      ...state,
      ...payload,
    };
  }

  if (type === ACTIONS.USER_IDENTIFICATION_CUE_ANALYTICS) {
    return {
      ...state,
      ...payload,
    };
  }

  return state;
}
